import React, { useRef, useState, useContext, useEffect } from "react";
import TokenHandle from "../../context/TokenHandle";
import Web3Context from "../../context/Web3Context";
import refHandle from "../../hooks/utils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast, { Toaster } from "react-hot-toast";

const dataRef_ = [
  {
    level: 1,
    porcentaje: "5%",
    amount: "3.1",
  },
  {
    level: 2,
    porcentaje: "3%",
    amount: "4.6",
  },
  {
    level: 3,
    porcentaje: "2%",
    amount: "1.8",
  },
];

function CardRef() {
  const {
    userData,
    allData,
    invest,
    withdraw,
    reinvestment,

    updateHandle,
  } = useContext(TokenHandle);
  const { accounts, isLoaded } = useContext(Web3Context);
  const [amount, setamount] = useState(0.1);
  const [dataRef, setdataRef_] = useState(dataRef_);

  const [copyText, setcopyText] = useState(window.location.origin);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isLoaded) return;
    const link = `${window.location.origin}?ref=${accounts}`;
    setcopyText(link);
    // `${window.location.href}?ref=${accounts}`
    return () => {};
  }, [accounts, isLoaded]);

  useEffect(() => {
    // console.log(userData, "data_data_data_data_data_data_");

    const data_ = [
      {
        level: 1,
        porcentaje: "8%",
        amount: userData.referrerCount_[0],
      },
      {
        level: 2,
        porcentaje: "2%",
        amount: userData.referrerCount_[1],
      },
      {
        level: 3,
        porcentaje: "1%",
        amount: userData.referrerCount_[2],
      },
      {
        level: 4,
        porcentaje: "0.5%",
        amount: userData.referrerCount_[3],
      },
      {
        level: 5,
        porcentaje: "0.5%",
        amount: userData.referrerCount_[4],
      },
    ];

    setdataRef_(data_);
    return () => {};
  }, [userData]);

  const onCopy = () => {
    setIsCopied(true);
    toast.success("Personal link Copied Successfully");
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
    console.log("hola");
  };

  return (
    <div className="max-w-7xl mx-auto px-6">
      <Toaster position="top-right" />

      <div className="flex items-center">
        <h1 className="flex-1 text-slate-900 font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-center mt-20">Referral Program</h1>
      </div>

        <div className="border-t border-gray-400 px-4 py-5 sm:p-0 max-w-xl mx-auto mt-9">
        <dl className="divide-y divide-gray-400">
{
  dataRef.map((data,i) => {
    return (
      <div key={i} className="py-4 sm:py-5 flex items-center justify-between sm:gap-4 sm:px-6">
      <dt className="text-sm font-medium text-slate-900">Level {data.level}: <span className="text-black ml-4">{data.porcentaje}</span></dt>
      <dd className="mt-1 text-sm text-slate-700 font-bold sm:mt-0 sm:col-span-2">
        {data.amount} <span className="text-purple-600"></span>
      </dd>
    </div>
    )
  })
}
        </dl>
      </div>

      <div className="text-center">
        <div className="lg:px-28 px-4 mt-4">
          <div className="rounded-lg shadow-sm bg-white px-6 py-5 shadow-sm flex justify-center">
            <div className="flex justify-center">
              <p className="text-sm font-medium text-gray-900">
                You will get your ref link after investing
              </p>
            </div>
          </div>
        </div>
        <div className="lg:px-28 px-4 mt-4">
          <CopyToClipboard
            text={copyText}
            onCopy={() => {
              onCopy();
            }}
            className="cursor-pointer mt-2 transition duration-150 w-full ease-in-out bg-slate-900 hover:bg-slate-700 text-white font-semibold py-3 px-5 rounded-lg"
          >
            <div className="flex justify-center">
              <p className="text-sm font-medium">
                {isCopied ? "COPIED" : "COPY"}
              </p>
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
}

export default CardRef;
